"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VarsClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
const to_date_time_string_1 = require("./utils/to-date-time-string");
class VarsClient extends authenticated_client_1.AuthenticatedClient {
    getDynamicVarKeys(projectId, from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            params.append('from', (0, to_date_time_string_1.toDateTimeString)(from));
            params.append('to', (0, to_date_time_string_1.toDateTimeString)(to));
            const response = yield this.httpGet(`/v1/projects/${projectId}/dynamicvar/keys?${params.toString()}`);
            return response.payload || [];
        });
    }
    searchDynamicVarKeys(projectId, from, to, searchSubstring) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            params.append('from', (0, to_date_time_string_1.toDateTimeString)(from));
            params.append('to', (0, to_date_time_string_1.toDateTimeString)(to));
            params.append('searchSubstring', searchSubstring);
            const response = yield this.httpGet(`/v1/projects/${projectId}/dynamicvar/keys?${params.toString()}`);
            return response.payload || [];
        });
    }
    searchDynamicVarKeysV2(projectId, from, to, searchSubstring, pageId, searchSubstrings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            params.append('from', (0, to_date_time_string_1.toDateTimeString)(from));
            params.append('to', (0, to_date_time_string_1.toDateTimeString)(to));
            if (searchSubstring) {
                params.append('searchSubstring', searchSubstring);
            }
            if (searchSubstrings && searchSubstrings.length) {
                params.append('searchSubstrings', searchSubstrings.join(','));
            }
            if (pageId) {
                params.append('pageId', String(pageId));
            }
            const url = `/v1/projects/${projectId}/dynamicvar/page-keys?${params.toString()}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getDynamicVarValues(projectId, from, to, key, searchSubstring) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const payload = {
                from: (0, to_date_time_string_1.toDateTimeString)(from),
                to: (0, to_date_time_string_1.toDateTimeString)(to),
                key,
                searchSubstring,
            };
            const response = yield this.httpPost(`/v1/projects/${projectId}/dynamicvar/keys`, payload);
            return response.payload || {};
        });
    }
    getCustomVars(projectId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const page = pageId ? `?pageId=${pageId}` : '';
            const response = yield this.httpGet(`/v1/projects/${projectId}/custom-vars${page}`);
            return response.payload || [];
        });
    }
    searchCustomVarValues(projectId, cvarKey, searchSubstring) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const key = `?cvarKey=${encodeURIComponent(cvarKey)}`;
            const substring = `&searchSubstring=${encodeURIComponent(searchSubstring)}`;
            const response = yield this.httpGet(`/v1/projects/${projectId}/search-custom-var-values${key}${substring}`);
            return response.payload || [];
        });
    }
    getDistinctUrlAppsParts(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/distinct-url-parts`);
            return response.payload || [];
        });
    }
    getMappingAssistantVars(projectId, pageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const page = pageId ? `?pageId=${pageId}` : '';
            const response = yield this.httpGet(`/v1/projects/${projectId}/mapping-assistant-vars${page}`);
            return response.payload || [];
        });
    }
}
exports.VarsClient = VarsClient;
//# sourceMappingURL=vars.client.js.map